<template lang="pug">
  EditDialog(ref="EditDialog" :title="title" :recordId="record.id" :hasTitleSuffix="false" :displayDeleteButton="false"
    width="95%" labelSaveButton="LINEアカウント連携を行う"
    @save="save"
    :loadingSave="loading.save" :loadingDelete="loading.delete")
    template(v-slot:body)
      v-container(grid-list-md)
        v-layout(row wrap)
          v-flex(xs12)
            v-alert(:value="true" color="info" icon="info" outline) 以下の内容でLINEアカウントと連携します。
        v-layout(row wrap)
          v-flex(xs12)
            v-text-field(v-model="record.id" label="乗務員ID"  readonly box hide-details)
          v-flex(xs12)
            v-text-field(v-model="record.name" label="お名前"  readonly box hide-details)
          v-flex(xs12)
            v-text-field(v-model="record.deliveryCompanyNameOfficial" label="お勤め先"  readonly box hide-details)
          v-flex(xs12)
            v-text-field(v-model="record.mobile" label="電話番号"  readonly box hide-details)
</template>

<script>
import EditDialog from "@/components/common/dialog/EditDialog";

import ApiHandler from "../../mixin/ApiHandler";
import EditForm from "../../mixin/EditForm";

export default {
  components: {
    EditDialog
  },
  mixins: [ApiHandler, EditForm],
  data() {
    return {
      title: "LINEアカウント連携確認",
      record: {
        id: null,
        areaCd: null,
        name: null
      }
    };
  },
  methods: {
    openDialog(item) {
      this.initForm(item);
      this.$refs.EditDialog.openDialog();
    },
    closeDialog() {
      this.$refs.EditDialog.closeDialog();
    },
    save() {
      this.$emit("save");
      this.closeDialog();
    }
  }
};
</script>
